module.exports = __webpack_public_path__ + "img/5c7bce4.png";